import * as React from 'react';
import { Field, reduxForm, change, FieldArray, arrayRemove, arrayInsert } from 'redux-form';
//import InvoiceForm from '../forms/InvoiceForm';
import { TouchableOpacity, TouchableNativeFeedback, FlatList, ScrollView, Platform, Picker, Alert, StyleSheet } from 'react-native';
import {
	Container,
	Header,
	InputGroup,
	Content,
	Text,
	H2,
	H3,
	Label,
	List,
	ListItem,
	Item,
	Input,
	Icon,
	Toast,
	Form,
	Spinner,
	View,
	Left,
	Right,
	Body,
	Button,
	Title,
	Card,
	CardItem
} from 'native-base';
import MaterialDrop from '../components/materialDrop';

import { SwipeListView } from 'react-native-swipe-list-view';

import * as _ from 'lodash';

import FormFooter from '../components/formFooter';
import { textInput, moneyInput, renderPicker, renderDateField, displayInput } from './renderedComponents';
const Btn = Platform.OS == 'android' ? TouchableNativeFeedback : TouchableOpacity;

import CalCalDataApi from '../api/CalCalDataApi';
//import Moment from 'moment';

//const formatMoney = value => value; //to display
//const parseMoney = value => parseFloat(isNaN(value)?0:value).toFixed(2); //to store

function syncValidate(values, props) {
	//runs while field changing
	let errors = {};

	if (!values.description) errors.description = 'Required';
	if (parseFloat(values.paid) > 0 && values.account_id == 0) errors.account_id = 'Please select an account';

	return errors;
}

function asyncValidate(values, dispatch, props, field) {
	return new Promise((resolve, reject) => {
		//runs on BLUR for net, vat, payable, paid. So first update values
		//var value = Number(values[field]);
		//var Dispval = parseFloat(isNaN(value) ? 0 : value).toFixed(2);
		//console.log('changing ', field, Dispval);
		//dispatch(change('InvoiceForm', field, Dispval));
		//console.log('asyncValidate', arguments, this);

		resolve();
	});
}

class InvoiceForm extends React.Component {
	constructor(props) {
		super(props);

		this.initialState = {
			editingCust: false,
			editingItem: false
		};
		this.state = this.initialState;
		this.formRefs = [];
		//console.log('InvoiceForm - ', this.props);
	}

	componentDidMount() {}

	_toggleModal() {
		//this._changeFormVal('customer_id', Number(55).toString());
		this.setState({ adding: !this.state.adding });
	}

	/*_changeFormVal(field, val){
		console.log('setting ', field, val);
		this.props.dispatch(change('InvoiceForm', field, val));
		//this.props.dispatch(change('InvoiceForm', 'description', 'TEST'));
	}*/

	_renderCustomer(id) {
		const cust = _.find(this.props.customers, ['id', id]);
		const editable = this.props.initialValues.invoice_status == 'draft';
		return (
			!!cust && (
				<View style={{ flexDirection: 'column', flex: 1, justifyContent: 'space-between' }}>
					<TouchableOpacity
						style={{ flexGrow: 1, flexDirection: 'row', flexWrap: 'wrap' }}
						onPress={() => {
							editable ? this.props.editCustomer(id) : Alert.alert('Invoice saved', 'Customer details are already in this invoice');
						}}>
						<Text style={{ paddingVertical: 7, paddingLeft: 5 }}>To:</Text>
						<H3 style={{ paddingVertical: 5, marginHorizontal: 5 }}>{cust.display}</H3>
					</TouchableOpacity>
					<Field name="customerRef" component={textInput} maxLength={28} placeholder="Customer's Ref" disabled={!editable} style={{ maxWidth: 300, maxHeight: 42, flexShrink: 1 }} />
				</View>
			)
		);
	}

	_renderTotals(invoice) {
		const inv = this.props.type == 'Invoice';
		return (
			<>
				{!!this.props.vatReg && (
					<View style={styles.totalsLine}>
						<Text style={styles.totalLineText}>Subtotal</Text>
						<Field style={{ justifyContent: 'flex-end', flexShrink: 1 }} name="net" component={displayInput} minus={!inv} currency pre="£ " />
					</View>
				)}
				{!!this.props.vatReg && (
					<View style={styles.totalsLine}>
						<Text style={styles.totalLineText}>VAT</Text>
						<Field style={{ justifyContent: 'flex-end' }} name="vat" component={displayInput} minus={!inv} currency pre="£ " />
					</View>
				)}
				<View style={styles.totalsLine}>
					<Text style={styles.totalLineText}>Total</Text>
					<Field style={{ justifyContent: 'flex-end' }} name="payable" component={displayInput} minus={!inv} currency pre="£ " />
				</View>
			</>
		);
	}
	_renderItems = ({ fields, meta: { touched, error }, enableActions }) =>
		!!fields.length && (
			<SwipeListView
				data={fields.getAll()}
				renderItem={this._renderItem.bind(this)}
				leftOpenValue={55}
				rightOpenValue={-55}
				keyExtractor={(rowData, index) => {
					return rowData.id ? rowData.id.toString() : (0 - index).toString();
				}}
				renderHiddenItem={(data, rowMap, b) =>
					enableActions && (
						<View style={styles.rowBack}>
							<Button style={styles.hiddenBtn} onPress={() => this.copyRow(data.item, rowMap, data.index)}>
								<Icon active name="copy" />
							</Button>
							<Button danger style={styles.hiddenBtn} onPress={() => this.deleteRow(data.item, rowMap, data.index)}>
								<Icon name="trash" />
							</Button>
						</View>
					)
				}
			/>
		);

	_renderItem({ item, index }, rowMap) {
		if (!item) return;
		const inv = this.props.type == 'Invoice';
		const qty = inv ? Number(item.qty).toString() : (0 - Number(item.qty)).toString();
		const total = inv ? item.total : (0 - Number(item.total)).toFixed(2);
		return (
			<ListItem key={index} style={{ backgroundColor: '#FFF', paddingLeft: 0, marginLeft: 0, marginVertical: 0 }} onPress={() => this.props.openItem(item)}>
				<Left style={{ flex: 0.6 }}>
					<Text note>{item.ref}</Text>
				</Left>
				<Body>
					<Text>{item.description}</Text>
				</Body>
				<Right style={{ flex: 1 }}>
					{qty != 1 && (
						<Text note style={{ textAlign: 'right' }}>
							{qty} {item.unitname || ''}
							{Number(qty) != 1 && item.unitname == 'Hour' && 's'} @ £{item.unit}
						</Text>
					)}
					<Text>
						£{total} {item.discount > 0 && '- £' + item.discount}
					</Text>
				</Right>
			</ListItem>
		);
		/*
		<ListItem itemHeader><Text>Items</Text></ListItem>

							{this.props.initialValues.items.map(this._renderItem)}
							//dataSource={this.ds.cloneWithRows(fields)}
							*/
	}

	deleteRow(item, rowMap, index) {
		//_.filter(rows, row);
		console.log('delete ', index);
		this.props.dispatch(arrayRemove('InvoiceForm', 'items', index));
		if (rowMap[item.id]) rowMap[item.id].closeRow();
		setTimeout(this.props.reCalc, 400);
		//this._changeFormVal('items', [...this.state.itemArray, item])
	}

	copyRow(item, rowMap, index) {
		let newOne = { ...item };
		delete newOne.id;
		this.props.dispatch(arrayInsert('InvoiceForm', 'items', index, newOne));
		if (rowMap[item.id]) rowMap[item.id].closeRow();
		setTimeout(this.props.reCalc, 400);
	}

	changeStatus(res, i) {
		typeof i == 'number' && console.log(change('InvoiceForm', 'invoice_status', i == 0 ? 'sent' : 'overdue'));
	}

	render() {
		const { handleSubmit, pristine, reset, submitting, disabled, status } = this.props;
		//this.ds = new ListView.DataSource({ rowHasChanged: (r1, r2) => r1 !== r2 });
		const invoice = this.props.initialValues; //can only use things that are not going to change - customer and status
		const invoice_status = status || invoice.invoice_status;
		const sent = invoice_status == 'sent';
		const overdue = invoice_status == 'overdue';
		const draft = invoice_status == 'draft';
		const voided = invoice_status == 'void';
		this.formRefs = [];
		const inv = this.props.type == 'Invoice';

		const allowedStatuses = draft
			? [
					{ label: 'Open', value: 'draft' },
					{ label: 'Sent', value: 'sent' },
					{ label: 'Overdue', value: 'overdue' }
			  ]
			: voided
			? [{ label: 'Void', value: 'void' }]
			: [
					{ label: 'Sent', value: 'sent' },
					{ label: 'Overdue', value: 'overdue' }
			  ];

		//console.log(this.props);

		return (
			<Form onSubmit={this.props.handleSubmit} style={{ flex: 1, marginHorizontal: 8 }}>
				<View style={{ flexDirection: 'row', flexShrink: 1 }}>
					{this._renderCustomer(invoice.customer_id)}
					<ScrollView style={{ flex: 1, marginLeft: 5 }}>
						<Field name="expenseDate" component={renderDateField} pickerStyle={{ dateIcon: {}, dateInput: { borderColor: 'rgba(0, 0, 0, 0)' } }} disabled={!!disabled} style={{ flex: 1 }} />
						<View style={{ flexDirection: 'row' }}>
							<Icon style={{ marginLeft: 7, marginVertical: 8, color: sent ? 'green' : overdue ? 'red' : 'grey' }} name={sent ? 'checkbox' : 'document'} />
							<Field name="invoice_status" component={renderPicker} mode="dropdown" disabled={voided}>
								{allowedStatuses.map((item, i) => (
									<Picker.Item key={i} label={item.label} value={item.value} />
								))}
							</Field>
						</View>
						{this.props.categories.length > 2 && (
							<View style={{ flexDirection: 'row' }}>
								<Icon name="albums" style={[styles.labelIcon, { marginLeft: 7, marginRight: 0, marginVertical: 8 }]} />
								<Field name="takingCategory_id" disabled={!!disabled} component={renderPicker} prompt="Select category" mode="dropdown">
									{this.props.categories
										.filter(c => c.id > -1)
										.map((item, i) => (
											<Picker.Item key={i} label={item.categoryName} value={item.id} />
										))}
								</Field>
							</View>
						)}
					</ScrollView>
				</View>

				<Card style={{ flex: 6, minHeight: 200, flexWrap: 'nowrap', paddingBottom: 10, borderRadius: 10, backgroundColor: '#FFF' }}>
					<CardItem header bordered style={{ flexShrink: 1, backgroundColor: '#d0e2ec', borderTopLeftRadius: 10, borderTopRightRadius: 10, justifyContent: 'space-between', padding: 10 }}>
						<Text>Items</Text>
						{!disabled && (
							<>
								<Btn bordered style={{ flexDirection: 'row' }} onPress={() => this.props.onAddItem(false)}>
									<Icon name="add" style={{ paddingHorizontal: 10, marginHorizontal: 10, fontSize: 22, color: '#2f6483', fontWeight: '600' }} />
									<Text style={{ color: '#588198', fontWeight: '600' }}>Add Item</Text>
								</Btn>
								<Btn style={{ flexDirection: 'row' }} onPress={() => this.props.onAddItem(true)}>
									<Icon name="time" style={{ paddingHorizontal: 10, marginHorizontal: 10, fontSize: 22, color: '#2f6483' }} />
									<Text style={{ color: '#588198' }}>Add Labour</Text>
								</Btn>
							</>
						)}
					</CardItem>
					<ScrollView style={{ flex: 1 }}>
						<FieldArray name="items" component={this._renderItems.bind(this)} enableActions={draft} />
					</ScrollView>
				</Card>

				<View style={{ flexDirection: 'row', marginTop: 10, flexGrow: 1, flexBasis: 120 }}>
					<View style={{ flexDirection: 'column', flex: 3 }}>
						<Field style={{ flex: 2, flexBasis: 20, flexShrink: 1 }} name="note" disabled={!!disabled} placeholder="Notes" labelType="stacked" component={textInput} multiline numberOfLines={2} />
						<Field
							style={{ flex: 1, flexBasis: 45 }}
							name="paid"
							disabled={!!disabled}
							label={inv ? 'Paid Already' : 'Amount refunded'}
							component={moneyInput}
							withRef
							ref={c => this.formRefs.push(c)}
							minus={!inv}
						/>
						{!!this.props.showAccts && (
							<Field
								style={{ flex: 1, flexBasis: 45 }}
								name="account_id"
								disabled={!!disabled}
								label={inv ? 'To account' : 'From Account'}
								component={renderPicker}
								prompt="Select account"
								mode="dropdown">
								{this.props.accounts
									.filter(item => {
										return item.accountType < 2;
									})
									.map((item, i) => (
										<Picker.Item key={i} label={item.nickName} value={item.id} />
									))}
							</Field>
						)}
					</View>
					<View style={{ flex: 1, flexDirection: 'column', justifyContent: 'space-between', backgroundColor: '#a1c7dd', marginHorizontal: 0, padding: 8, paddingLeft: 15 }}>
						{this._renderTotals(invoice)}
					</View>
				</View>
			</Form>
		);
	}
}

const styles = StyleSheet.create({
	totalsLine: {
		flexDirection: 'row',
		flexWrap: 'wrap',
		flex: 1,
		flexBasis: 33,
		alignItems: 'stretch',
		justifyContent: 'flex-end'
	},
	totalLineText: { flexBasis: 65, flexGrow: 1, fontSize: 13, color: '#224f69' },
	addPerson: {
		//color: '#438eb9',
		alignSelf: 'center'
		//marginLeft: 20
	},
	labelIcon: {
		color: '#2f6483',
		alignSelf: 'center',
		marginRight: 20
	},
	footer: {
		backgroundColor: '#F8F8F8'
	},
	modalContainer: {
		flex: 1,
		justifyContent: 'center',
		backgroundColor: 'grey'
	},
	innerContainer: {
		alignItems: 'center'
	},
	rowBack: {
		alignItems: 'center',
		backgroundColor: '#DDD',
		flex: 1,

		flexDirection: 'row',
		justifyContent: 'space-between'
		//paddingLeft: 15
	},
	hiddenBtn: {
		width: 55,
		height: '100%'
	}
});

export default reduxForm({
	form: 'InvoiceForm',
	validate: syncValidate,
	asyncValidate: asyncValidate,
	asyncBlurFields: ['paid'] //cause a re-render
})(InvoiceForm);
